import { readonly, ref } from 'vue'

interface RatedFilesState {
  [key: string]: boolean
}

const ratedFiles = ref<RatedFilesState>({})
function addRatedFile(fileId: string) {
  if (fileId) {
    ratedFiles.value[fileId] = true
  }
}

function isFileRated(fileId: string): boolean {
  return !!ratedFiles.value[fileId]
}

export default function useRatedFiles() {
  return {
    ratedFiles: readonly(ratedFiles),
    addRatedFile,
    isFileRated,
  }
}
